<template>
  <span class="input-with-errors">
    <input
      type="text"
      class="asd-input"
      :class="{'asd-input-disabled': visibility > 0}"
      :value="valueHandler"
      @click="showEditor = true"
    />
    <Modal v-if="showEditor && visibility === 0">
      <template #default>
        <textarea
          :id="htmlId"
          v-model="valueHandler"
          v-validate.initial
          class="asd-input modal-textarea"
          :class="['asd-input--' + fieldsClasses[id]]"
          :required="valueRequired"
          :pattern="valuePattern"
          :name="id"
          :autocomplete="htmlId"
          data-vv-as=" "
          @blur="blur"
        />
      </template>
      <template #controls>
        <button
          class="asd-btn-confirm"
          @click="showEditor = false"
        >
          Budiž
        </button>
      </template>
    </Modal>
    <FormErrors
      v-if="fieldsClasses[id] !== 'pristine'"
      :id="id"
      :errorsObject="errors"
      :propertyType="propertyType"
    >
    </FormErrors>
  </span>
</template>

<script>
import FormErrors from 'CORE/components/form/errors'
import DataTypeMixin from 'CORE/mixins/dataType'
import _ from 'lodash'
import { createDataTypeValue } from '../utils'
import Modal from 'CORE/components/modal/modal'

export default {
    name: 'LongTextInput',
    components: {
        FormErrors,
        Modal,
    },
    mixins: [
        DataTypeMixin,
    ],
    data() {
        return {
            showEditor: false,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', '')
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    if (this.visibility === 0) {
                        this.$emit('input', createDataTypeValue(value))
                    }
                }
            },
        },
        valueRequired() {
            return _.get(this.propertyType, 'settings.validation.required', false)
        },
        valuePattern() {
            const pattern = _.get(this.propertyType, 'settings.validation.pattern', '')
            if (_.size(pattern) > 0) {
                return pattern
            }
            return false
        },
        fieldsClasses() {
            return _.mapValues(this.fields, value => {
                if (_.get(value, 'touched')) {
                    if (_.get(value, 'valid')) return 'valid'
                    if (_.get(value, 'invalid')) return 'invalid'
                }
                if (_.get(value, 'pristine')) return 'pristine'
            })
        },
        editorType() {
            return _.get(this.propertyType, 'settings.text_editor.type', 'plaintext')
        },
    },
    mounted() {
        const labelOptions = []
        if (_.get(this.propertyType, 'settings.default_value.enabled', false)) {
            if (this.value === null) {
                this.valueHandler = null
            }
            labelOptions.push('server-calculated')
        }
        if (_.get(this.propertyType, 'settings.validation.required', false)) {
            labelOptions.push('required')
        }
        this.$emit('labelOptions', labelOptions)
    },
    methods: {
        blur() {
            this.$emit('blur')
        },
    },
}
</script>

<style lang="scss" scoped>
.modal-textarea {
    width: 80vw;
    min-height: 50vh;
}
</style>